module.exports = __webpack_public_path__ + "img/20210823_114711.6f50040b.jpg";